import { render, staticRenderFns } from "./LoadingPending.vue?vue&type=template&id=34812e8a&"
import script from "./LoadingPending.vue?vue&type=script&lang=js&"
export * from "./LoadingPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports